module.exports = __webpack_public_path__ + "best-rate.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/best-rate.svg
// module id = 484
// module chunks = 0